import React from 'react';
import PropTypes from 'prop-types';

import { SubscriptionContextProvider } from './subscription';

const GlobalContext = ({ children }) => {
  return <SubscriptionContextProvider>{children}</SubscriptionContextProvider>;
};

GlobalContext.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalContext;
